import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import GridModule from '../../common/component/GridModule';
import HomeFooter from '../../common/component/HomeFooter';
import useMainListEventHandler from '../hook/useMainListEventHandler';

export default function WufPlusList() {
  const wufPlus = useTypedSelector(state => state.main.wufPlus);
  const isEmpty =
    !wufPlus || (!wufPlus.bigContent && wufPlus.contents?.length === 0);

  const {handleClickBigContent, handleClickContent} = useMainListEventHandler();

  return (
    <>
      <FetchResultWrapper
        showLoading={!wufPlus}
        showNoItems={isEmpty}
        noItemsProps={{textKey: 'schedule_empty'}}
      >
        {wufPlus ? (
          <GridModule
            item={wufPlus}
            showAllContents
            onClickBigContent={({content, index}) =>
              handleClickBigContent({item: wufPlus, content, index})
            }
            onClickContent={({content, index}) =>
              handleClickContent({item: wufPlus, content, index})
            }
          />
        ) : (
          <></>
        )}
      </FetchResultWrapper>
      <HomeFooter isBottomFixed={isEmpty} />
    </>
  );
}
